import { z } from 'zod';

/**
 * The one API error envelope shape (see `docs/04-api-contract.md`). Every non-2xx
 * response from the Worker serialises to this; both React apps parse it. Defined
 * here so the shape can never drift between server and clients.
 */
export const errorEnvelopeSchema = z.object({
  statusCode: z.number().int(),
  message: z.string(),
  error: z.string(),
  // Correlation id (M9, ADR 0023) — echoes the response `x-request-id` so a user-reported error
  // ties to the server log line. Optional/additive: present on server-generated errors (notably
  // 500s), absent on client-side envelopes; existing consumers that ignore it are unaffected.
  requestId: z.string().optional(),
});

export type ErrorEnvelope = z.infer<typeof errorEnvelopeSchema>;
